/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/podcast_medium'
export default icon
